import { render, staticRenderFns } from "./SliderV11.vue?vue&type=template&id=55280b78&"
import script from "./SliderV11.vue?vue&type=script&lang=js&"
export * from "./SliderV11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports